<div id="information-recruit-view2">

	<div class="recruit-add1">
	  <table>
	  <colgroup>
	    <col style="width:14%">
	    <col style="width:36%">
	    <col style="width:14%">
	    <col style="width:36%">
	  </colgroup>

	  <tbody>
	  <tr>
	    <td colspan="4" class="title">
        {{board.subject}}
	      <span class="fr wdate">{{board.write_date.substr(0, 10)}}</span>
	    </td>
	  </tr>
	  <tr class="tr-ul">
	    <td colspan="4" class="td-ul">
	      <ul class="recruit-table">
	        <li>
				    <p class="th">전공</p>
				    <p class="td">{{board.speciality}}</p>
				  </li>
				  <li>
				    <p class="th">급여</p>
				    <p class="td">{{board.salary}}</p>
				  </li>
				  <li>
				    <p class="th">이름</p>
				    <p class="td">{{board.name}} (생년월일 : {{board.birthday}})</p>
          </li>
          <li>
				    <p class="th">희망업무</p>
				    <p class="td">{{board.recuritment_part}}</p>
				  </li>
				  <li>
				    <p class="th">학력</p>
				    <p class="td">{{board.academic_ability}}</p>
          </li>
          <li>
				    <p class="th">연락처</p>
				    <p class="td">{{board.tel}}</p>
				  </li>
				  <li>
				    <p class="th">이메일</p>
				    <p class="td">{{board.contact_email}}</p>
          </li>
          <li>
				    <p class="th">경력구분</p>
				    <p class="td">{{board.career}}</p>
				  </li>
				</ul>
	    </td>
	  </tr>
	  <tr>
	    <th>홈페이지</th>
      <td colspan="3"><p class="td"><a [attr.href]="'//' + board.website" target="_blank" title="{{board.website}}">{{board.website}}</a></p></td>
	  </tr>
	  <tr>
	    <th>주 소</th>
      <td colspan="3"><span *ngIf="board.zipcode !== ''">({{board.zipcode}})&nbsp;</span>{{board.address}} {{board.address_detail}}</td>
	  </tr>
	  <tr>
	    <th>내용</th>
	    <td colspan="3">
        <span [innerHTML]="board.contents_nl2br"></span>
	    </td>
	  </tr>
	  </tbody>
	  </table>

	  <div class="btn-area">
      <button class="list-btn" (click)="list()">목록</button>

      <ng-container *ngIf="authEditCheck( board.writer )">
        <span style="margin-left: 10px;"></span>
        <button class="edit-btn" (click)="modify()">수정</button>
        <span style="margin-left: 10px;"></span>
        <button class="edit-btn" (click)="setBoardJobSearchDelete()">삭제</button>
      </ng-container>
	  </div>
	</div>
</div>
